document.addEventListener("DOMContentLoaded", function() {

	var accordion = document.querySelectorAll('.accordion__handle');
	if (accordion) {
		accordion.forEach(function(item) {
			item.addEventListener('click', function() {
				var expanded = this.getAttribute('aria-expanded'),
				did = this.getAttribute('aria-controls'),
				target = document.getElementById(did);

				// Find the parent accordion container
				var parentAccordion = this.closest('.accordion');

				// If we're opening this accordion (currently closed)
				if (expanded === 'false') {
					// Close all other accordions within the same parent container
					if (parentAccordion) {
						var siblingHandles = parentAccordion.querySelectorAll('.accordion__handle');
						var siblingBodies = parentAccordion.querySelectorAll('.accordion__body');

						siblingHandles.forEach(function(handle) {
							if (handle !== item) { // Don't affect the clicked item
								handle.setAttribute('aria-expanded', 'false');
								handle.classList.remove('is-active');
							}
						});

						siblingBodies.forEach(function(body) {
							if (body !== target) { // Don't affect the target body
								body.classList.remove('is-open');
							}
						});
					}
				}

				// Toggle the clicked accordion
				if (target) {
					target.classList.toggle('is-open');
				}

				expanded = expanded == 'true' ? 'false' : 'true';

				this.setAttribute("aria-expanded", expanded);
				this.classList.toggle('is-active');
			});
		});
	}

	// Auto-expand the first accordion item in each accordion container
	var accordionContainers = document.querySelectorAll('.accordion');
	accordionContainers.forEach(function(container) {
		var firstHandle = container.querySelector('.accordion__handle');
		if (firstHandle) {
			var firstBodyId = firstHandle.getAttribute('aria-controls');
			var firstBody = document.getElementById(firstBodyId);

			if (firstBody) {
				// Set the first accordion as expanded
				firstHandle.setAttribute('aria-expanded', 'true');
				firstHandle.classList.add('is-active');
				firstBody.classList.add('is-open');
			}
		}
	});

	var showAll = document.getElementById('toggleAll');
	var accordionBtns = document.querySelectorAll('.accordion__handle');
	var accordionItems = document.querySelectorAll('.accordion__body');

	if(showAll) {
		showAll.addEventListener('click', function(e) {
			e.preventDefault();
			for (var i = 0; i < accordionItems.length; i++) {
				accordionItems[i].classList.add('is-open');
			}
			for (var x = 0; x < accordionBtns.length; x++) {
				accordionBtns[i].setAttribute("aria-expanded", "true");
				accordionBtns[i].classList.add('is-active');
			}
		});
	}

	var getAccordion = window.location.hash.substring(1),
	accordionEntry = false;

	if (getAccordion.length > 0) {
		try {
			accordionEntry = document.getElementById(getAccordion);
		} catch(e) { }
	}

	if (accordionEntry) {
		var did = accordionEntry.getAttribute('aria-controls'),
		target = document.getElementById(did);

		if (target) {
			target.classList.toggle('is-open');
		}
	}

});
